import { Button } from '@/components/button';
import { Text } from '@/components/text';

import type { Distributor } from '@energy-retailer/schema';

const DistributorItem = ({ name, contact: { faults }, url }: Distributor) => (
  <div
    role="listitem"
    className="flex w-full justify-between gap-d border-t border-gray-200 py-c max-md:flex-col md:gap-b md:py-b"
  >
    <div className="flex flex-col justify-between">
      <Text
        as="h4"
        variant="body2"
        weight="semi"
      >
        {name}
      </Text>
      <Text
        as="p"
        variant="body3"
      >
        Faults and Emergencies:{' '}
        <a
          href={`tel:${faults}`}
          style={{ fontSize: 'inherit' }}
        >
          {faults}
        </a>
      </Text>
    </div>
    <div>
      <Button
        variant="secondary"
        href={url}
        target="_blank"
      >
        Visit Website
      </Button>
    </div>
  </div>
);

export default DistributorItem;
